import { ReactNode } from 'react';

import { cn } from '../../../../utils';
import Link from '../links/link';

type ButtonType = {
    children: ReactNode;
    onClick?: () => void;
    className?: string;
    href?: string;
    target?: string;
    light?: boolean;
    smaller?: boolean;
    small?: boolean;
    big?: boolean;
};

const Button = (props: ButtonType) => {
    let colorScheme = 'border-purple-900 bg-purple-600 text-light hover:border-purple-800 hover:bg-purple-500';
    if (props.light) {
        colorScheme = 'border-gray-200 bg-gray-50 text-gray-600 hover:border-gray-300 hover:bg-gray-100';
    }

    let size = 'px-3 py-1.5 text-sm';
    if (props.smaller) {
        size = 'px-2 py-1 text-xs';
    } else if (props.big) {
        size = 'px-4 py-2 text-base';
    }

    const defaultClass =
        'inline-flex items-center gap-x-1.5 border inline-flex items-center rounded-lg font-medium border cursor-pointer';

    if (!props.href) {
        return (
            <button onClick={props.onClick} className={cn(defaultClass, props.className || '', colorScheme, size)}>
                {props.children}
            </button>
        );
    }

    return (
        <Link
            href={{
                pathname: props.href,
            }}
            target={props.target || '_blank'}
            className={cn(defaultClass, props.className || '', colorScheme, size)}
        >
            {props.children}
        </Link>
    );
};

export default Button;
